import { JSX } from 'preact'
import classnames from 'classnames'
import { WidgetLayout } from '@gsc/types'
import { GeneralLayout } from './GeneralLayout'
import { PanelLayout } from './PanelLayout'
import { ModalLayout } from './ModalLayout'
import { LayoutProps } from './interfaces'

export function Layout({ layout, className, ...rest }: LayoutProps): JSX.Element {
  const props = {
    className: classnames('root', className),
    ...rest,
  }

  switch (layout) {
    case WidgetLayout.Modal:
      return <ModalLayout {...props} />
    case WidgetLayout.Panel:
      return <PanelLayout {...props} />
    default:
      return <GeneralLayout layout={layout} {...props} />
  }
}
